import { TooltipArrow } from '@/ui/Tooltip';
import { TooltipContent } from '@/ui/Tooltip';
import { TooltipTrigger } from '@/ui/Tooltip';
import { Tooltip } from '@/ui/Tooltip';
import { TooltipProvider } from '@/ui/Tooltip';
import { useEffect } from 'react';
import { useState } from 'react';
import type React from 'react';
import { useRef } from 'react';

type TooltipWrapperProps = React.PropsWithChildren<{
  tooltipText: string;
  portalId: string;
  isTriggerAsChild?: boolean;
  shouldMount?: boolean;
}>;

export const TooltipWrapper = ({
  tooltipText,
  portalId,
  children,
  isTriggerAsChild = true,
  shouldMount = true,
}: TooltipWrapperProps) => {
  const container = useRef<HTMLElement | null>(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const el = document.getElementById(portalId);
    if (el) {
      container.current = el;
    }
    setIsMounted(true);
  }, [portalId]);

  if (!isMounted || !shouldMount) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild={isTriggerAsChild}>{children}</TooltipTrigger>
        {/* @ts-expect-error container ref isn't really null */}
        <TooltipContent container={container}>
          <div className="px-2 py-1 text-sm text-white bg-gray-800 rounded">{tooltipText}</div>
          <TooltipArrow />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
